/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description idGetUrlUsingGet参数
 * @property `id` 文章或问题id
 * @property `[type]` 分享内容 ARTICLE文章  QUESTION问题
 */
export interface ParamsidGetUrlUsingGet {
  // pathParams
  /**
   * 文章或问题id
   */
  id: number;
  // queryParams
  /**
   * 分享内容 ARTICLE文章  QUESTION问题
   */
  type?: string;
}
/**
 * @description idShareUsingGet参数
 * @property `id` 文章或问题id
 * @property `[shortUrl]` 短链接的url
 * @property `[type]` 分享内容 ARTICLE文章  QUESTION问题
 */
export interface ParamsidShareUsingGet {
  // pathParams
  /**
   * 文章或问题id
   */
  id: number;
  // queryParams
  /**
   * 短链接的url
   */
  shortUrl?: string;
  /**
   * 分享内容 ARTICLE文章  QUESTION问题
   */
  type?: string;
}
/**
 * @description shareShortKeyUsingGet参数
 * @property `shortKey` 短链接的key
 */
export interface ParamsshareShortKeyUsingGet {
  // pathParams
  /**
   * 短链接的key
   */
  shortKey: string;
}
export class ShareApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary getShareUrl
   * @param params ParamsidGetUrlUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultstring
   */
  public idGetUrlUsingGet = (
    params: ParamsidGetUrlUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultstring> => {
    const path = '/api/{id}/getUrl';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary share
   * @param params ParamsidShareUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public idShareUsingGet = (
    params: ParamsidShareUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/{id}/share';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('shortUrl' in params) p.query.shortUrl = params.shortUrl;
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 通过参数重定向到文章信息页面
   * @param params ParamsshareShortKeyUsingGet
   
   * @param opt ajax config
   * @returns string
   */
  public shareShortKeyUsingGet = (
    params: ParamsshareShortKeyUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<string> => {
    const path = '/api/share/{shortKey}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.shortKey, 'shortKey');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new ShareApi();
